export const HOME = {
  nav: "nav-bar",
  navLogo: "nav-logo",
  navLinkInfo: "nav-link-info",
  navLinkInscripcions: "nav-link-inscripcions",
  navLinkCategories: "nav-link-categories",
  navLinkGaleria: "nav-link-galeria",
  navLinkContacte: "nav-link-contacte",
  navCtaInscribe: "nav-cta-inscribe",
  heroSection: "hero-section",
  heroCountdownDays: "countdown-days",
  heroCountdownHours: "countdown-hours",
  heroCountdownMinutes: "countdown-minutes",
  heroCountdownSeconds: "countdown-seconds",
  heroCtaInscribe: "hero-cta-inscribe",
  heroCtaInfo: "hero-cta-info",
  inscripcionsSection: "inscripcions-section",
  inscripcionsPriceCard: "inscripcions-price-card",
  inscripcionsSamarretaCard: "inscripcions-samarreta-card",
  caminadaInfoCard: "caminada-info-card",
  categoriesSection: "categories-section",
  serveisSection: "serveis-section",
  galeriaSection: "galeria-section",
  classificacioSection: "classificacio-section",
  normativaSection: "normativa-section",
  organitzacioSection: "organitzacio-section",
  patrocinadorsSection: "patrocinadors-section",
  contacteSection: "contacte-section",
  contactForm: "contact-form",
  contactFormName: "contact-form-name",
  contactFormEmail: "contact-form-email",
  contactFormMessage: "contact-form-message",
  contactFormSubmit: "contact-form-submit",
  footer: "footer",
};
